import { FETCH_CATEGORIES, LOADING_SET } from "./actionType";

export const fetchCategorySuccess = (payload) => {
	return {
		type: FETCH_CATEGORIES,
		payload,
	};
};

export const loadingSet = (payload) => {
	return {
		type: LOADING_SET,
		payload,
	};
};

export const fetchCategories = () => (dispatch) => {
	dispatch(loadingSet(true));
	return fetch("https://terkini-rysaldi.herokuapp.com/admin/categories", {
		headers: {
			access_token: localStorage.access_token,
		},
	})
		.then(async (res) => {
			if (!res.ok) {
				const isJson = res.headers.get("content-type")?.includes("application/json");
				const data = isJson ? await res.json() : null;
				const error = (data && data.message) || res.status;
				return Promise.reject(error);
			}
			return res.json();
		})
		.then((data) => {
			dispatch(fetchCategorySuccess(data));
		})
		.finally(() => {
			dispatch(loadingSet(false));
		});
};

export const addCategory = (newCategory) => (dispatch) => {
	dispatch(loadingSet(true));
	return fetch("https://terkini-rysaldi.herokuapp.com/admin/categories", {
		method: "POST",
		body: JSON.stringify(newCategory),
		headers: {
			"Content-Type": "application/json",
			access_token: localStorage.access_token,
		},
	}).then(async (res) => {
		if (!res.ok) {
			const isJson = res.headers.get("content-type")?.includes("application/json");
			const data = isJson ? await res.json() : null;
			const error = (data && data.message) || res.status;
			return Promise.reject(error);
		}
		return res.json();
	});
};

export const editCategory = (categoryId, editedCategory) => (dispatch) => {
	dispatch(loadingSet(true));
	return fetch(`https://terkini-rysaldi.herokuapp.com/admin/categories/${categoryId}`, {
		method: "PUT",
		body: JSON.stringify(editedCategory),
		headers: {
			"Content-Type": "application/json",
			access_token: localStorage.access_token,
		},
	}).then(async (res) => {
		if (!res.ok) {
			const isJson = res.headers.get("content-type")?.includes("application/json");
			const data = isJson ? await res.json() : null;
			const error = (data && data.message) || res.status;
			return Promise.reject(error);
		}
		return res.json();
	});
};

export const deleteCategory = (categoryId) => (dispatch) => {
	dispatch(loadingSet(true));
	return fetch(`https://terkini-rysaldi.herokuapp.com/admin/categories/${categoryId}`, {
		method: "DELETE",
		headers: {
			access_token: localStorage.access_token,
		},
	})
		.then(async (res) => {
			if (!res.ok) {
				const isJson = res.headers.get("content-type")?.includes("application/json");
				const data = isJson ? await res.json() : null;
				const error = (data && data.message) || res.status;
				return Promise.reject(error);
			}
			return res.json();
		})
		.then(() => {
			dispatch(fetchCategories());
		});
};

export const fetchDetailCategory = (categoryId) => (dispatch) => {
	dispatch(loadingSet(true));
	return fetch(`https://terkini-rysaldi.herokuapp.com/admin/categories/${categoryId}`, {
		headers: {
			access_token: localStorage.access_token,
		},
	}).then(async (res) => {
		if (!res.ok) {
			const isJson = res.headers.get("content-type")?.includes("application/json");
			const data = isJson ? await res.json() : null;
			const error = (data && data.message) || res.status;
			return Promise.reject(error);
		}
		return res.json();
	});
};
